import React from 'react';
// import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';

const NavItem = withRouter((props) => {
  const { router, onlyActiveOnIndex, to, children, target } = props;
  const isActive = router.isActive(to, onlyActiveOnIndex);
  const linkProps = Object.assign({}, { onlyActiveOnIndex, to, target });
  return (
    <li className={isActive ? 'active' : ''}>
      <Link {...linkProps}>{children}</Link>
    </li>
  );
});

NavItem.propTypes = {
  router: PropTypes.func,
  index: PropTypes.number,
  onlyActiveOnIndex: PropTypes.bool,
  to: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/common/ui/NavItem.jsx